import { JsonLdResource } from '../base';
import { ResourceCollection } from '../collection';
import { HydraCollection } from '../hydra/hydra-collection';

export class ResourceCollectionFactory {
  public static createFromHydraCollection<T extends JsonLdResource>(collection: HydraCollection<T>): ResourceCollection<T> {
    return new ResourceCollection<T>(
      collection.members,
      ResourceCollectionFactory.getCurrentPage(collection),
      ResourceCollectionFactory.getTotalPages(collection),
      collection.totalItems,
      ResourceCollectionFactory.getItemsPerPage(collection),
      collection.view?.id || '',
    );
  }

  private static getCurrentPage(collection: HydraCollection<any>): number {
    const queryString = collection.view?.id.replace(collection.id, '');
    const queryParams = new URLSearchParams(queryString);
    const pageParam = queryParams.get('page');

    return pageParam ? parseInt(pageParam, 10) : 1;
  }

  private static getTotalPages(collection: HydraCollection<any>): number {
    const queryString = (collection.view?.hydraLast ?? '').replace(collection.id, '');
    const params = new URLSearchParams(queryString);

    const pageParam = params.get('page');

    return pageParam ? parseInt(pageParam, 10) : 1;
  }

  private static getItemsPerPage(collection: HydraCollection<any>): number {
    const totalPages = this.getTotalPages(collection);
    const totalItems = collection.totalItems;

    return Math.ceil(totalItems / totalPages);
  }
}
